// Design token map — Editorial Vitality design system
// Source: /stitch/stitch/home_page_youthful_professional/code.html (Tailwind config, lines 15–67)

const tokens = {
  colors: {
    // Core brand
    primary: '#a0412d',
    'on-primary': '#fff7f6',
    'primary-container': '#ffac9b',
    'on-primary-container': '#721f0f',
    'primary-fixed': '#ffac9b',
    'primary-fixed-dim': '#ff9782',
    'on-primary-fixed': '#540900',
    'on-primary-fixed-variant': '#7e2817',
    'primary-dim': '#913523',
    'inverse-primary': '#fa846c',

    // Secondary (teal)
    secondary: '#006b63',
    'on-secondary': '#e2fff9',
    'secondary-container': '#84f5e8',
    'on-secondary-container': '#005c55',
    'secondary-fixed': '#84f5e8',
    'secondary-fixed-dim': '#75e7da',
    'on-secondary-fixed': '#004842',
    'on-secondary-fixed-variant': '#00675f',
    'secondary-dim': '#005e56',

    // Tertiary (warm neutral)
    tertiary: '#635f53',
    'on-tertiary': '#fff8ed',
    'tertiary-container': '#fbf3e4',
    'on-tertiary-container': '#605b50',
    'tertiary-fixed': '#fbf3e4',
    'tertiary-fixed-dim': '#ece5d6',
    'on-tertiary-fixed': '#4d493f',
    'on-tertiary-fixed-variant': '#6b665a',
    'tertiary-dim': '#575348',

    // Surface hierarchy (tonal stacking — no border lines rule)
    background: '#fff8f5',
    surface: '#fff8f5',
    'surface-bright': '#fff8f5',
    'surface-container-lowest': '#ffffff',
    'surface-container-low': '#fcf2ed',
    'surface-container': '#f6ece6',
    'surface-container-high': '#f1e6e0',
    'surface-container-highest': '#ece0d9',
    'surface-dim': '#e4d8d0',
    'surface-variant': '#ece0d9',
    'surface-tint': '#a0412d',
    'inverse-surface': '#110e0b',

    // On-surface text
    'on-surface': '#38312d',
    'on-background': '#38312d',
    'on-surface-variant': '#665d58',
    'inverse-on-surface': '#a39b98',

    // Outline
    outline: '#827973',
    'outline-variant': '#bbb0aa',

    // Error
    error: '#ac3149',
    'on-error': '#fff7f7',
    'error-container': '#f76a80',
    'on-error-container': '#68001f',
    'error-dim': '#770326',
  },

  fonts: {
    headline: "'Epilogue', sans-serif",
    body: "'Plus Jakarta Sans', sans-serif",
    label: "'Plus Jakarta Sans', sans-serif",
  },

  radii: {
    sm: '0.25rem',
    lg: '0.5rem',
    xl: '0.75rem',
    '2xl': '1rem',
    '3xl': '1.5rem',
    full: '9999px',
  },

  shadows: {
    editorial: '0 20px 40px rgba(56, 49, 45, 0.06)',
    card: '0 4px 16px rgba(56, 49, 45, 0.08)',
  },

  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
  },
};

export default tokens;
